import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {RiskGroupPaymentType} from '~local/app/types/RiskGroupPaymentType';
import {UserRiskGroupPaymentType} from '~local/app/types/UserRiskGroupPaymentType';

export type PaymentGroupFees = {
    profile: string,
    code: string,
    paymentTypes: Record<string, Array<RiskGroupPaymentType>>,
};

export type PaymentGroupUserFees = {
    profile: string,
    code: string,
    paymentTypes: Record<string, Array<UserRiskGroupPaymentType>>,
};

export type RiskGroupCommissionsList = {
    riskGroups: Array<string>,
    paymentFees: Array<PaymentGroupFees>,
};

export type UserRiskGroupCommissionsList = {
    riskGroups: Array<string>,
    paymentFees: Array<PaymentGroupFees | PaymentGroupUserFees>,
};

export type UpdateRiskGroupPaymentType = Pick<
    RiskGroupPaymentType,
    'id'
    | 'platformFlat' | 'platformPercentage' | 'platformMin' | 'platformMax'
    | 'serviceProviderFlat' | 'serviceProviderPercentage' | 'serviceProviderMin' | 'serviceProviderMax'
>;

@Injectable()
export class CommissionService {
    constructor(private http: HttpClient) {}

    public updatePaymentFee($updates: Array<UpdateRiskGroupPaymentType>): Observable<Array<RiskGroupPaymentType>> {
        return this.http.put<Array<RiskGroupPaymentType>>('/admin/commission/riskgroupfee/', {
            paymentTypes: $updates,
        });
    }

    public getRiskGroupPayments($type: string): Observable<RiskGroupCommissionsList> {
        return this.http.get<RiskGroupCommissionsList>(`/admin/commission/riskgroupfee/list/${$type}`);
    }

    public getUserRiskGroupPayments($userId: number): Observable<UserRiskGroupCommissionsList> {
        return this.http.get<UserRiskGroupCommissionsList>(`/admin/commission/user/riskgroupfee/list/${$userId}`);
    }

    public postUserPaymentFee(formData: {
        userId: number;
        commisionFees: { id: number; amount: number; minCommissionAmount?: number; code?: string }[];
    }): Observable<any> {
        return this.http.post('/admin/commission/user/riskgroupfee/', formData);
    }

    public getProductList(type: string): Observable<any> {
        return this.http.get<any>(`/admin/commission/product/list/${type}`);
    }

    public updateProduct(formData: any): Observable<any> {
        return this.http.put('/admin/commission/product/', formData);
    }

    public resetUserCommissions(userId: number): Observable<any> {
        return this.http.delete<any>(`/admin/commission/delete/user/riskgroupfee/${userId}`);
    }
}
